export default `
  query categoryList($filters: CategoryFilterInput!) {
    categoryList(filters: $filters) {
      id
      uid
      url_path
      url_suffix
      include_in_menu
      is_anchor
      name
      level
      position
      product_count
      breadcrumbs{
        category_id
        category_url_path
        category_name
      }
    }
  }
`
